export default class AdmQuiz {

    constructor() {
        this.data = null;

        this.currentMusee = 0;
        this.currentCategorie = null;
        this.currentQuizz = 0;
        this.currentQuestion = 0;
        this.score = 0
        this.indice = 0
        this.indiceGood = 0
        this.indiceTraceur = false
        this.totalQuestions = 19 // default = 19
        this.elem = document.documentElement;
        this.isFullscreen = false;

        this.progressbarWidth = 0;
    }

    init() {
        this.loadJSON((response) => {

            setTimeout(() => {

                this.data = JSON.parse(response);

                var museeId = 0;

                this.currentMusee = museeId;
                this.ready = true;
            }, 100);
        });
    }



    // 
    // 
    // Display and remove pages
    // 
    // 

    // Close the menu to go on the level page
    close() {
        const element = document.getElementById("launcher");
        element.style.display = "none"
        var removebtn = document.getElementById("btn-fullscreen")
        var removeinfos = document.getElementById("infos-fullscreen")
        removebtn.style.display = "none"
        removeinfos.style.display = "none"
    }

    // Close the level page to go on the quizz page
    closeLevel() {
        const element = document.getElementById("level-content");
        element.style.display = "none"
        var remove = document.getElementById("btn-fullscreen")
        remove.style.display = "none"
    }

    // Close the quizz page to go on the question page
    closeQuizz() {
        const element = document.getElementById("quizz-content");
        element.style.display = "none"

        // Display lvl on the top of the next page
        var junior = document.getElementById("display-junior")
        var decouverte = document.getElementById("display-decouverte")
        var expert = document.getElementById("display-expert")
        var space = document.getElementById("space")
        var spaceExp = document.getElementById("space-exp")
        if (this.currentLevel == 0) {
            junior.style.display = "block"
            space.style.display = "block"
            console.log('Niveau Junior')
        } else if (this.currentLevel == 1) {
            decouverte.style.display = "block"
            console.log('Niveau Decouverte')
        } else if (this.currentLevel == 2) {
            expert.style.display = "block"
            spaceExp.style.display = "block"
            console.log('Niveau Expert')
        }

    }

    // Close the score page to go on the bonus page
    closeScore() {
        const element = document.getElementById("score-content");
        element.style.display = "none"
    }

    // Close the bonus page to go on the zoom page
    closeBonus() {
        const element = document.getElementById("bonus-content");
        element.style.display = "none"
    }

    juniorLevel() {
        this.currentLevel = 0
        this.closeLevel()
    }

    decouverteLevel() {
        this.currentLevel = 1
        this.closeLevel()
    }

    expertLevel() {
        this.currentLevel = 2
        this.closeLevel()
    }

    setQuizz(quizzID) {
        this.currentQuizz = this.data[this.currentMusee].collections[0].quizz.findIndex(x => x.id == quizzID)
        console.log(this.currentQuizz)

        // Get quizz title

        if (this.currentQuizz == 0 || this.currentQuizz == 1) {
            document.getElementById("quizz-title").innerHTML = "Yeux";
        } else if (this.currentQuizz == 2 || this.currentQuizz == 3) {
            document.getElementById("quizz-title").innerHTML = "Mains";
        } else if (this.currentQuizz == 4 || this.currentQuizz == 5) {
            document.getElementById("quizz-title").innerHTML = "Eros";
        } else if (this.currentQuizz == 6 || this.currentQuizz == 7) {
            document.getElementById("quizz-title").innerHTML = "Thanatos";
        } else if (this.currentQuizz == 8) {
            document.getElementById("quizz-title").innerHTML = "Animaux";
        } else if (this.currentQuizz == 9) {
            document.getElementById("quizz-title").innerHTML = "Enfants";
        } else if (this.currentQuizz == 10) {
            document.getElementById("quizz-title").innerHTML = "Anges";
        }
    }

    displaySettings() {
        const settings = document.getElementById("settings-content");
        settings.style.display = "block"
    }

    closeSettings() {
        const settings = document.getElementById("settings-content");
        settings.style.display = "none"
    }

    backToBonus() {
        var bonus = document.getElementById("bonus-content")
        bonus.style.display = "block"
    }

    displayAbout(refresh) {
        const about = document.getElementById("about-content");
        about.style.display = "block"

        const closeButton = document.getElementById("close-about")
        if(refresh){
             closeButton.addEventListener('click', () => {
                // console.log('true donc refresh');
                this.refreshPage()
             })
        }else{
            closeButton.addEventListener('click', () => {
                // console.log('false donc close');
                this.closeAbout()
            })
        }
    }

    closeAbout() {
        const about = document.getElementById("about-content");
        about.style.display = "none"
    }

    displayRules() {
        const rules = document.getElementById("rules-content");
        rules.style.display = "block"
    }

    closeRules() {
        const rules = document.getElementById("rules-content");
        rules.style.display = "none"
    }

    removeIndice() {
        var indice = document.getElementById("hidden")
        indice.style.display = "none"
    }

    displayBonus() {
        var bonus = document.getElementById("hidden-img")
        bonus.style.display = "block"
    }

    displayBonusDesc() {
        var bonus = document.getElementById("desc")
        bonus.style.display = "block"
    }

    removeBonusDesc() {
        var indice = document.getElementById("desc")
        indice.style.display = "none"
    }

    displayIndisponible() {
        var indisponible = document.getElementById("indisponible")
        indisponible.style.display = "block"
        indisponible.style.fontSize = "larger"

        setInterval(() => {
            indisponible.style.display = "none"
        }, 3000);
    }



















    jumpTop() {
        console.log('Jump to top !')
        const scrollBtn = document.querySelector("#jump-top");
        scrollBtn.addEventListener("click", () => {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        });
    }






    // 
    //  Resultats, points, changement de question, suivi de progres...
    // 


    changeQuestion(questionID) {
        this.currentQuestion = this.data[this.currentMusee].collections[0].quizz[this.currentQuizz].questions.findIndex(x => x.position == questionID)
        if (this.currentQuestion < this.totalQuestions) {
            this.currentQuestion = this.currentQuestion + 1
        } else {
            const element = document.getElementById("questions-content");
            element.style.display = "none"

            document.getElementById("note").innerHTML = this.score * 5;
            document.getElementById("note20").innerHTML = this.score + "/" + (this.totalQuestions + 1);
            document.getElementById("note-indice").innerHTML = this.indice;
            document.getElementById("note-indice-good").innerHTML = this.indiceGood;
        }

        var total = document.getElementById("triangle")
        total.style.marginLeft = this.score * 4.7 + "%"


        // ProgressBar
        var progressbar = document.getElementById("progressbar")
        var progress = document.getElementById("progressbar-content")

        progress.style.width = progress.offsetWidth + 0.05 * progressbar.offsetWidth + "px";
        var width = progress.offsetWidth / progressbar.offsetWidth
        if (width >= 1) {
            progress.style.width = progressbar.offsetWidth + "px";
        }
        this.progressbarWidth = progress.style.width
    }





    setAnswer0() {
        this.answer = 0
        this.setAnswer()
    }

    setAnswer1() {
        this.answer = 1
        this.setAnswer()
    }

    setAnswer2() {
        this.answer = 2
        this.setAnswer()
    }

    setAnswer3() {
        this.answer = 3
        this.setAnswer()
    }




    setAnswer() {
        this.good = this.data[this.currentMusee].collections[0].quizz[this.currentQuizz].questions[this.currentQuestion].good

        if (this.answer == this.good) {
            if (this.indiceTraceur == true) {
                this.indiceGood = this.indiceGood + 1
                this.indiceTraceur = false
            }
            this.goodAnswer()
        } else {
            this.wrongAnswer()
            this.indiceTraceur = false
        }
    }






    goodAnswer() {
        var good = document.getElementById("good-answer")
        // window.setTimeout(function(){
        good.style.display = "block"
        // },800);
        this.score = this.score + 1
        window.navigator.vibrate(100);
    }

    wrongAnswer() {
        var wrong = document.getElementById("wrong-answer")
        // window.setTimeout(function(){
        wrong.style.display = "block"
        // },800);
        window.navigator.vibrate([75, 100]);
    }

    getIndice() {
        var indice = document.getElementById("hidden")
        indice.style.display = "block"
        this.indice = this.indice + 1
        this.indiceTraceur = true
    }



    /****
    ********
    **** Window
    **  ******
    */


    toggleFullscreen() {
        if (this.isFullscreen)
            this.closeFullscreen();
        else
            this.openFullscreen();
    }

    openFullscreen() {
        if (this.elem.requestFullscreen) {
            this.elem.requestFullscreen();
        } else if (this.elem.webkitRequestFullscreen) { /* Safari */
            this.elem.webkitRequestFullscreen();
        } else if (this.elem.msRequestFullscreen) { /* IE11 */
            this.elem.msRequestFullscreen();
        }
        this.isFullscreen = true;
        // var remove = document.getElementById("infos-fullscreen")
        // remove.style.display = "none"
        // const fullscreenButton = document.querySelector(".fullscreen-container");
        // fullscreenButton.style.backgroundColor = "red";
    }

    closeFullscreen() {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) { /* Safari */
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { /* IE11 */
            document.msExitFullscreen();
        }
        this.isFullscreen = false;
        // const fullscreenButton = document.querySelector(".fullscreen-container");
        // fullscreenButton.style.backgroundColor = "transparent";
    }



    refreshPage() {
        window.location.reload();
    }

    loadJSON(callback) {

        var xobj = new XMLHttpRequest();
        xobj.overrideMimeType("application/json");
        xobj.open('GET', './data.json', true); // Replace 'my_data' with the path to your file
        xobj.onreadystatechange = function () {
            if (xobj.readyState == 4 && xobj.status == "200") {
                // Required use of an anonymous callback as .open will NOT return a value but simply returns undefined in asynchronous mode
                callback(xobj.responseText);
            }
        };
        xobj.send(null);
    }
}
